import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { Icons } from '@/font-awesome';
import CommonButton from '../CommonButton.vue';
import { AdminUser } from '@/models/admins/admin_model';


export default /*@__PURE__*/_defineComponent({
  __name: 'QRCodeTwoFactorContent',
  props: {
    currentPage: { type: Number, required: true },
    adminUser: { type: Object, required: true },
    qrCodeUrl: { type: String, required: true },
    secret: { type: String, required: true }
  },
  emits: ["change-page"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const isCopied = ref(false);

function openUrl(url: string) {
  window.open(url, '_blank');
}

function handleCopyClick() {
  navigator.clipboard.writeText(props.secret);
  isCopied.value = true;
  setTimeout(() => {
    isCopied.value = false;
  }, 3000);
}




const __returned__ = { props, isCopied, openUrl, handleCopyClick, get Icons() { return Icons }, CommonButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})